<template>
    <div class="publication__filters content-width">

        <div class="d-flex">

            <div class="publication__section-inner d-flex">
                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('donors_weight')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in filtersServer.weight">
                            <label class="d-flex">
                                <input type="radio" v-model="weight" :value="key">
                                <span class="circle"></span>
                                {{value}}
<!--                                {{$store.getters.t(
                                key === 'up_to_3' ? 'donors_weight_up_to_3' :
                                    (key === '3_6' ? 'donors_weight_3_6' :
                                        (key === '6_10' ? 'donors_weight_6_10' :
                                            (key === '10_15' ? 'donors_weight_10_15' :
                                                (key === '15_25' ? 'donors_weight_15_25' :
                                                    (key === '25_35' ? 'donors_weight_25_35' :
                                                        (key === '35_plus' ? 'donors_weight_35_plus' : 'donors_weight_not_specified')))))))
                                }}-->
                            </label>
                        </div>
                    </div>


                </div>
            </div>

        </div>

        <div class="publication__filters-row">

            <div class="publication__filters-title">
                {{$store.getters.t('publication_pet_filters_additional')}}
            </div>

            <div class="publication__filters-grid d-flex">
                <label class="publication__filters-item" v-for="filter in filtersServer.pet_filter_id" :key="filter.id">

                    <div class="publication__filters-item-inner d-flex" :class="{'publication__filters-item-inner--selected': filters.indexOf(filter.id) >= 0 }">
                        <div class="publication__filters-item-heading">
                            <div class="publication__filters-item-icon d-flex" :style="{background: filter.color}" >
                                <img :src="`/assets/images/${filter.icon}`" alt="">
                            </div>
                            <div class="publication__filters-item-name">
                                {{filter.name}}
                            </div>
                            <div class="publication__filters-item-description">
                                {{$store.getters.t(filtersDescription[ filter.name_en ])}}
                            </div>
                        </div>

                        <div class="publication__filters-item-body">
                            <div class="publication__filters-item-checkbox">
                                <input type="checkbox" :value="filter.id" v-model="filters">
                            </div>
                        </div>

                    </div>

                </label>
            </div>

            <div class="text-danger" v-show="!$v.filters.maxLength" >{{$store.getters.t('publication_pet_filters_no_more_than_4')}}</div>

        </div>
        <div class="publication__filters-row">

            <div class="publication__filters-title">
                {{$store.getters.t('personal_filters_social_attributes')}}
            </div>

            <div class="publication__social d-flex">

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_children', value: to_children}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_children)" >{{`${to_children}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_to_children')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_cats', value: to_cats}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_cats)" >{{`${to_cats}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_to_cats')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_dogs', value: to_dogs}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_dogs)" >{{`${to_dogs}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_to_dogs')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'enrichment', value: enrichment}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(enrichment)" >{{`${enrichment}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_home_behavior')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'human_sociability', value: human_sociability}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(human_sociability)" >{{`${human_sociability}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_socialization')}}
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>



const filtersDescription = {
    'Old': 'publication_pet_filter_desc_old',
    'Disabled': 'publication_pet_filter_desc_disabled',
    'Seeking for home': 'publication_pet_filter_desc_seeking_home',
    'Sos situations': 'publication_pet_filter_desc_sos',
    'Donor': 'publication_pet_filter_desc_donor',
    'Homestay': 'publication_pet_filter_desc_homestay',
    'PR': 'publication_pet_filter_desc_pr',
    'Supervisor': 'publication_pet_filter_desc_supervisor',
    'Auto aid': 'publication_pet_filter_desc_auto_aid',
    'Captured': 'publication_pet_filter_desc_captured',
    'Photo aid': 'publication_pet_filter_desc_photo_aid',
};

import { required, maxLength, requiredIf} from 'vuelidate/lib/validators';

import Star from '../PublicationSocialStar';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PetFilters",
    props: ['server'],
    components: { Star },
    mixins: [StateMixin],
    computed: {

        filtersServer(){ return this.server.dictionaries },
        filtersDescription() { return filtersDescription },

        filters: {
            get() { return this.GET_BY_KEY('filters') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'filters', data: val})
            }
        },

        weight: {
            get() { return this.GET_BY_KEY('weight') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'weight', data: val})
            }
        },

        to_children: {
            get() { return this.GET_BY_KEY('to_children') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_children', data: val || 'null'})
            }
        },

        to_dogs: {
            get() { return this.GET_BY_KEY('to_dogs') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_dogs', data: val || 'null'})
            }
        },

        to_cats: {
            get() { return this.GET_BY_KEY('to_cats') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_cats', data: val || 'null'})
            }
        },

        human_sociability: {
            get() { return this.GET_BY_KEY('human_sociability') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'human_sociability', data: val || 'null'})
            }
        },

        enrichment: {
            get() { return this.GET_BY_KEY('enrichment') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'enrichment', data: val || 'null'})
            }
        },



    },



    methods: {

        handleSocial({ target, rate }){
            this[target] = rate;
        },

        isValid() {
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        filters: {
            required: requiredIf( function () {
                return Array.isArray( this.filters ) && this.filters.length > 4
            } ),
            maxLength: maxLength(4)
        }
    }


}
</script>

<style scoped>

</style>
